exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/** \n* Пагинация =====================================================\n*/\n/**\n* Хлебные крошки\n*/\n.action-container[data-v-3c253498] {\n  width: 100%;\n  background-color: #f2fbfa;\n  padding: 120px 0;\n}\n@media screen and (max-width: 575.98px) {\n.action-container .action-time__title[data-v-3c253498] .text__inner {\n    font-size: 32px;\n}\n}\n@media screen and (max-width: 575.98px) {\n.action-container .action-time__desc[data-v-3c253498] .text__inner {\n    font-size: 24px;\n}\n}\n.text-center[data-v-3c253498] {\n  text-align: center;\n}", ""]);

// exports
